module.exports = "label {\n    color: rgb(31, 112, 191)\n}\n\n.center {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main